/** Date intervals indexed once, including long intervals crossing other rows. */
export class PlanningIntervalIndex<T> {
    private readonly entries: { row: T; start: number; end: number }[];
    private readonly maxEnds: Float64Array;

    constructor(rows: readonly T[], range: (row: T) => { start: number; end: number }) {
        this.entries = rows.map(row => ({ row, ...range(row) })).sort((a, b) => a.start - b.start);
        this.maxEnds = new Float64Array(this.entries.length * 4);
        if (this.entries.length) this.build(1, 0, this.entries.length - 1);
    }

    public overlapping(start: number, end: number): T[] {
        const result: T[] = [];
        if (start < end && this.entries.length) this.visit(1, 0, this.entries.length - 1, start, end, result);
        return result;
    }

    private build(node: number, low: number, high: number): number {
        if (low === high) return this.maxEnds[node] = this.entries[low].end;
        const middle = (low + high) >>> 1;
        return this.maxEnds[node] = Math.max(this.build(node * 2, low, middle), this.build(node * 2 + 1, middle + 1, high));
    }

    private visit(node: number, low: number, high: number, start: number, end: number, result: T[]): void {
        if (this.maxEnds[node] <= start || this.entries[low].start >= end) return;
        if (low === high) { result.push(this.entries[low].row); return; }
        const middle = (low + high) >>> 1;
        this.visit(node * 2, low, middle, start, end, result);
        this.visit(node * 2 + 1, middle + 1, high, start, end, result);
    }
}
